export default "__VITE_ASSET__DbRoZFiu__"